export default function memberProfilePath(memberId){
  if(!memberId){
    return "#";
  }
  return "/members/"+memberId;
}
